import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { useToast } from '../../hooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: ('owner' | 'worker' | 'admin')[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();
  const toast = useToast();

  const forbidden = Boolean(
    isAuthenticated && allowedRoles && user && !allowedRoles.includes(user.role),
  );

  // Tell the user why they got bounced instead of silently dropping them on the
  // dashboard (which reads like the page failed or doesn't exist).
  useEffect(() => {
    if (forbidden) {
      toast.error("You don't have access to that page.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forbidden]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (forbidden) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
